import pipe from "@insightfulscience/shared-utils/fn/pipe";
import { withLoading } from "../nprogress";
import { ViewerForm } from "../services/hubspot";
import routes, { gotoPath } from "../routes";

const actionForm = form => ViewerForm.submit(form).then(gotoPath(routes.snapgeneViewerDownload));

export default pipe(actionForm, withLoading("request-trial"));
